import { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/apiClient';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('bulaccino-theme');
    if (saved) return saved === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });
  const [darkModeEnabled, setDarkModeEnabled] = useState(true);

  // Fetch setting from API
  useEffect(() => {
    api.get('/settings')
      .then(res => {
        setDarkModeEnabled(res.data.dark_mode_enabled !== false);
      })
      .catch(err => console.error('Failed to fetch theme settings:', err));
  }, []);

  useEffect(() => {
    if (isDarkMode && darkModeEnabled) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('bulaccino-theme', isDarkMode ? 'dark' : 'light');
  }, [isDarkMode, darkModeEnabled]);

  const toggleDarkMode = () => {
    if (darkModeEnabled) {
      setIsDarkMode(prev => !prev);
    }
  };

  return (
    <ThemeContext.Provider value={{
      isDarkMode: isDarkMode && darkModeEnabled,
      toggleDarkMode,
      darkModeEnabled
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}
